//import store from '../../store'
import * as Const from './Constants';
import { bus } from '../../app.js'

export class Progress{
    #functionCount;
    #percentageValue;
    #progressIncrement;
    #progressMaxValue;
    #counter;
    #isValueSet;
    #loadingMessage;
  
    constructor(){
        this.#resetValues();
    }

    //private functions
    #resetValues = () =>{
        this.#percentageValue  = Const.ZERO_VAL;
        this.#progressIncrement = Const.ZERO_VAL;
        this.#functionCount = 0;
        this.#progressMaxValue = Const.PROGRESS_FULL; 
        this.#counter = 0; 
        this.#isValueSet = false;    
        this.#loadingMessage = `${Const.LOADING}...`;    
    }

    //setters
    set functionCount(functionCount) {
        this.#functionCount = functionCount;
        this.#progressIncrement = Math.floor(Const.PROGRESS_FULL/this.#functionCount);
        this.#progressMaxValue = this.#progressIncrement * this.#functionCount;
    } 

    set loadingMessage(value) {
        this.#loadingMessage = value;
    } 

    set percentageValue(value) {
        this.#percentageValue = value;
    } 

    set isValueSet(value){
        this.#isValueSet = value;
    }

    //getters
    get functionCount(){
        return this.#functionCount;
    }

    get isValueSet(){
        return this.#isValueSet;
    }

    get percentageValue(){
        return this.#percentageValue;
    }

    get progressIncrement(){
        return this.#progressIncrement;
    }

    //public function
    show = async () =>{
        let tmpObj = { LoadingValue: true, LoadingPercentage: '0', LoadingDisplay: this.#loadingMessage }
        bus.$emit('showLoadingProgress', tmpObj)    
        await new Promise(r => setTimeout(r, 500));   
    }

    reset = async (functionCount) =>{
        this.#resetValues();
        this.#functionCount = functionCount;
        this.#progressIncrement = Math.floor(Const.PROGRESS_FULL/this.#functionCount);
        this.#progressMaxValue = this.#progressIncrement * this.#functionCount;

        let tmpObj = { LoadingValue: true, LoadingPercentage: '0', LoadingDisplay: this.#loadingMessage }
        bus.$emit('showLoadingProgress', tmpObj)    
        await new Promise(r => setTimeout(r, 500));  
    }

    hide = async () =>{
        this.#resetValues();
        let tmpObj = { LoadingValue: false, LoadingPercentage: '0', LoadingDisplay: null }
        bus.$emit('showLoadingProgress', tmpObj)
    }

    addPercentageManual = (value) =>{
        this.#percentageValue += this.#percentageValue;
        let tmpObj = { LoadingValue: true, LoadingPercentage: this.#percentageValue.toString(), LoadingDisplay: this.#loadingMessage }

        bus.$emit('showLoadingProgress', tmpObj)
    }

    forceComplete = async () =>{
            let tmpObj = { LoadingValue: true, LoadingPercentage: '100', LoadingDisplay: this.#loadingMessage }
            bus.$emit('showLoadingProgress', tmpObj)

            this.#resetValues();
            await new Promise(r => setTimeout(r, 500));
            tmpObj = { LoadingValue: false, LoadingPercentage: '0', LoadingDisplay: null }
            bus.$emit('showLoadingProgress', tmpObj)
    }

    increment = async (multiplier = null) =>{
        if(this.#functionCount == 0) return;

        if(multiplier){
            this.#percentageValue = this.#percentageValue + (this.#progressIncrement * multiplier);   
        }else{
            this.#percentageValue = this.#percentageValue + this.#progressIncrement;
        }

        //this.#percentageValue = this.#percentageValue + this.#progressIncrement;

        let tmpObj = { LoadingValue: true, LoadingPercentage: this.#percentageValue.toString(), LoadingDisplay: this.#loadingMessage } 
        bus.$emit('showLoadingProgress', tmpObj)

        this.#counter++

        if(this.#percentageValue >= this.#progressMaxValue){
            this.#resetValues();

            await new Promise(r => setTimeout(r, 500));
            let tmpObj = { LoadingValue: false, LoadingPercentage: '0', LoadingDisplay: null }
            bus.$emit('showLoadingProgress', tmpObj)
        }
    }

    indeterminate = () =>{
        let percentageValue = 0
        const tmpObj = { LoadingValue: true, LoadingDisplay: this.#loadingMessage, LoadingPercentage: null }
        
        const loaderInterval = setInterval(function() {
            percentageValue = percentageValue += 1;
            tmpObj.LoadingPercentage = percentageValue.toString()

            bus.$emit('showLoadingProgress', tmpObj)

            if (percentageValue === 100){

                const tmpObj = { LoadingValue: false, LoadingDisplay: '', LoadingPercentage: '0' }
                bus.$emit('showLoadingProgress', tmpObj)
                clearInterval(loaderInterval);   
            }
        }, 10);
    }
}//end class






